import { z } from 'zod';

/**
 * Realtime domain events streamed from the backend (SSE) to invalidate client
 * caches. This is transient wire data — pub/sub is fire-and-forget and lossy and
 * nothing is persisted — so it is a ValidationSchema, and the consumer
 * `safeParse`s every frame. Events are thin: a `type` plus only the ids needed
 * to choose which cache keys to invalidate. `dealershipId` is the per-dealership
 * channel / tenant key carried on every event.
 *
 * Add a variant to the union (and a matching case in `applyServerEvent`) as more
 * queries adopt the cache key factory.
 */
const TransactionUpdatedValidationSchema = z.object({
  type: z.literal('transaction.updated'),
  dealershipId: z.string(),
  transactionId: z.string()
});

export const ServerEventValidationSchema = z.discriminatedUnion('type', [
  TransactionUpdatedValidationSchema
]);

export type ServerEventValidationSchema = z.TypeOf<
  typeof ServerEventValidationSchema
>;
